import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SensorEventNotification, SensorEventParse, SensorEventType} from "../../ParseClass/SensorEvent.Parse";
import {IconService} from "../../providers/service/icon.service";

@Component({
    selector: 'app-box-sensor-event',
    templateUrl: './box-sensor-event.component.html',
    styleUrls: ['./box-sensor-event.component.scss'],
    standalone: false
})
export class BoxSensorEventComponent implements OnInit {
    @Input() sensorEvent: SensorEventParse | undefined;
    @Input() disabled: boolean | undefined
    @Output() clickButton = new EventEmitter<ClickBoxSensorButtonsType>()

    constructor(private iconServce: IconService) {
        this.iconServce.addSvgIcon('winterSummer', '/assets/icon/temperature/estateInverno.svg')
        this.iconServce.addSvgIcon('flame', '/assets/icon/energy/flame.svg')
    }

    ngOnInit(): void {
    }

    predicateBool(value: boolean | undefined): 'primary' | undefined {
        if (value == true) {
            return 'primary'
        } else {
            return undefined
        }
    }


    predicateNotification(value: any | undefined): 'primary' | undefined {
        if (value != null) {
            return 'primary'
        } else {
            return undefined
        }
    }

    predicateType(value: SensorEventType | undefined): { icon?: string, svgIcon?: string, color: 'primary' | 'warn' | 'accent', tooltipText: string } | undefined {
        if (value == null) {
            return undefined
        } else if (value == SensorEventType.WINTER) {
            return {icon: 'ac_unit', color: 'primary', tooltipText: 'sensorEventType.winter'}
        } else if (value == SensorEventType.SUMMER) {
            return {icon: 'wb_sunny', color: 'primary', tooltipText: 'sensorEventType.summer'}
        } else if (value == SensorEventType.ANY) {
            return {svgIcon: 'winterSummer', color: 'primary', tooltipText: 'sensorEventType.any'}
        } else {
            return {icon: 'alert', color: 'warn', tooltipText: 'sensorEventType.nonPrevisto'}
        }
    }

    openNotification(sensorEvent: SensorEventParse|undefined) {
        this.clickButton.next({type: BoxSensorButtons.openNotification, element: sensorEvent})
    }
}

export type ClickBoxSensorButtonsType = {
    type:  BoxSensorButtons;
    element?: SensorEventParse
}

export enum BoxSensorButtons {
    openNotification
}